// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyB5I3_91X_owdmUQYMnAzUr_HGfQ9fQ7ME",
  authDomain: "darkcrypto.firebaseapp.com",
  projectId: "darkcrypto",
  storageBucket: "darkcrypto.firebasestorage.app",
  messagingSenderId: "397739339167",
  appId: "1:397739339167:web:097765f7ea27013a1061aa",
  measurementId: "G-M5TX9RD255"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); // מייצאים את db
